import { lazy } from "react";
import Loadable from "app/components/Loadable";

const NotFound = Loadable(lazy(() => import("./NotFound")));
const ForgotPassword = Loadable(lazy(() => import("./ForgotPassword")));
const Unauthorized = Loadable(lazy(() => import("./Unauthorized")));
// const FirebaseLogin = Loadable(lazy(() => import("./login/FirebaseLogin")));
// const FirebaseRegister = Loadable(lazy(() => import("./register/FirebaseRegister")));

const JwtLogin = Loadable(lazy(() => import("./login/JwtLogin")));
// const JwtRegister = Loadable(lazy(() => import("./register/JwtRegister")));

// const Auth0Login = Loadable(lazy(() => import("./login/Auth0Login")));

const sessionRoutes = [
  // {
  //   path: "/session/signup/aduH8hG0ivES6Nls5zIzrudLj0nVW7yxrYSDmy/mlA",
  //   element: <JwtRegister />,
  // },
  { path: "/session/signin", element: <JwtLogin /> },
  { path: "/session/forgot-password", element: <ForgotPassword /> },
  { path: "/session/unauthorized", element: <Unauthorized /> },
  { path: "*", element: <NotFound /> }
];

export default sessionRoutes;
